import React from "react";
import { Box, useTheme } from "@mui/material";
import ServiceTag from "../ServiceTag";
import AssignedEmployee from "./AssignedEmployee";
import * as f from "../../utils/formatter";
import VirtualCareTag from "../VirtualCareTag.jsx";

export default function ResourceExtraInfo({ appointments, setChangeEmployee }) {
  const clients = appointments.map((a) => a.client);
  const theme = useTheme();

  return (
    <Box
      sx={{
        marginTop: "1.2rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        fontSize: "1rem",
        lineHeight: "1.1rem",
        gap: "5px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "0.2rem",
          width: "100%",
        }}
      >
        <VirtualCareTag client={clients[0]} />
        <Box
          className="single-line"
          sx={{ color: theme.palette.background.dark, fontWeight: 600 }}
        >
          {clients.length === 1
            ? (f.fullName(clients[0]) ?? <>&nbsp;</>)
            : `(${clients.length})`}
        </Box>
      </Box>
      <ServiceTag service={appointments[0]?.service} />
      <AssignedEmployee
        appointments={appointments}
        setChangeEmployee={setChangeEmployee}
      />
    </Box>
  );
}
